var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgViacertaLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 209 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M23.001,8.904l-8.615,20.364l-5.73,0l-8.657,-20.364l5.977,0l2.638,6.595l2.968,8.038l2.927,-8.038l2.638,-6.595l5.853,0Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.433,3.215c0,-1.896 1.401,-3.215 3.339,-3.215c1.937,0 3.38,1.319 3.38,3.215c0,1.814 -1.443,3.133 -3.38,3.133c-1.938,0 -3.339,-1.319 -3.339,-3.133m0.577,5.689l5.483,0l0,20.364l-5.483,0l0,-20.364Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.586,8.904l0,20.364l-4.74,0l-0.371,-2.474c-1.69,1.896 -4.163,2.927 -7.049,2.927c-5.853,0 -9.893,-4.369 -9.893,-10.635c0,-6.266 4.04,-10.635 9.893,-10.635c2.885,0 5.4,1.031 7.049,2.886l0.371,-2.432l4.74,0Zm-5.441,10.182c0,-3.421 -2.309,-5.854 -5.606,-5.854c-3.257,0 -5.565,2.432 -5.565,5.854c0,3.421 2.308,5.854 5.565,5.854c3.297,0 5.606,-2.432 5.606,-5.854",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.626,19.086c0,-6.348 4.41,-10.635 10.965,-10.635c3.009,0 5.647,1.072 7.832,3.174l-3.174,3.421c-1.154,-1.154 -2.762,-1.814 -4.452,-1.814c-3.38,0 -5.73,2.391 -5.73,5.854c0,3.463 2.308,5.854 5.73,5.854c1.814,0 3.463,-0.701 4.699,-1.979l3.215,3.463c-2.308,2.226 -4.905,3.298 -8.038,3.298c-6.719,0 -11.047,-4.163 -11.047,-10.635",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.672,20.899l-15.705,0c0.371,2.556 2.597,4.246 5.895,4.246c2.185,0 4.37,-0.742 5.689,-1.937l3.05,3.133c-2.144,2.184 -5.4,3.462 -8.945,3.462c-6.884,0 -11.254,-4.163 -11.254,-10.676c0,-6.348 4.329,-10.635 10.718,-10.635c7.378,0 11.46,4.864 10.553,12.408m-15.623,-3.628l10.47,0c-0.206,-2.638 -2.185,-4.287 -5.235,-4.287c-2.885,0 -4.823,1.566 -5.235,4.287",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.788,10.347l-2.391,4.246c-1.154,-0.783 -2.144,-1.072 -3.298,-1.072c-3.009,0 -4.946,2.102 -4.946,5.812l0,9.935l-5.483,0l0,-20.364l4.741,0l0.454,2.556c1.566,-2.102 3.503,-2.968 5.73,-2.968c1.896,0 3.875,0.618 5.194,1.855",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.318,28.525c-1.69,0.783 -3.174,1.072 -4.988,1.072c-4.163,0 -6.925,-2.226 -6.925,-7.544l0,-8.657l-3.669,0l0,-4.493l3.669,0l0,-5.194l5.441,-0.577l0,5.771l5.482,0l0,4.493l-5.482,0l0,8.657c0,1.855 0.948,2.803 2.597,2.803c0.783,0 1.731,-0.247 2.432,-0.577l1.443,4.246Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.226,8.904l0,20.364l-4.741,0l-0.371,-2.474c-1.69,1.896 -4.163,2.927 -7.049,2.927c-5.853,0 -9.893,-4.369 -9.893,-10.635c0,-6.266 4.04,-10.635 9.893,-10.635c2.886,0 5.4,1.031 7.049,2.886l0.371,-2.432l4.741,0Zm-5.441,10.182c0,-3.421 -2.309,-5.854 -5.606,-5.854c-3.257,0 -5.565,2.432 -5.565,5.854c0,3.421 2.308,5.854 5.565,5.854c3.297,0 5.606,-2.432 5.606,-5.854",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.505,30.097c-5.21,-0.895 -9.234,-4.772 -10.336,-9.414c-1.234,-5.199 1.067,-10.466 5.302,-13.174c4.076,-2.605 9.079,-2.875 13.23,-0.748l2.588,-3.362c-2.912,-1.615 -6.281,-2.411 -9.803,-2.178c-10.075,0.668 -17.274,9.538 -15.783,19.021c1.478,9.397 10.969,16.03 20.807,13.688c3.659,-0.871 6.76,-3.019 8.927,-5.866l-3.09,-3.012c-2.489,3.669 -6.889,5.896 -11.843,5.045",
    style: {
      fill: "#f15a22",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.782,13.445l-3.276,2.538l8.556,10.335l13.482,-17.866c-0.607,-0.975 -2.091,-2.535 -2.832,-3.291l-10.847,14.367l-5.084,-6.083Z",
    style: {
      fill: "#f15a22",
      fillRule: "nonzero"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgViacertaLogo);
export default __webpack_public_path__ + "static/media/viacerta-logo.5085a488.svg";
export { ForwardRef as ReactComponent };